import { PositionRequest } from '@/main/models/request/positionRequest';
import { PositionTypes, PositionActionTypes } from './positionTypes';
import { PositionResponse } from '@/main/models/response';

export function getPosition(
  request: PositionRequest,
  keyReducer: string = 'default'
): PositionActionTypes {
  return {
    type: PositionTypes.GET_POSITION,
    payload: { request, keyReducer }
  };
}

export function getPositionWithIdPIES(
  request: PositionRequest,
  keyReducer: string = 'default'
): PositionActionTypes {
  return {
    type: PositionTypes.GET_POSITION_IDPIES,
    payload: { request, keyReducer }
  };
}

export function savePosition(
  data: PositionResponse[] | null,
  isError: boolean,
  errorMessages: string[] | null,
  keyReducer: string = 'default'
): PositionActionTypes {
  return {
    type: PositionTypes.SAVE_POSITION,
    payload: { data, isError, errorMessages, keyReducer }
  };
}

export function resetReducerPosition(
  keyReducer: string = 'default'
): PositionActionTypes {
  return {
    type: PositionTypes.RESET_REDUCER_POSITION,
    payload: { keyReducer }
  };
}

